import Vue from 'vue'

import {
  Button, Form, FormItem, Input,
  Header, Container, Aside, Main, Footer,
  Menu, MenuItem, MenuItemGroup, Submenu, Option,
  RadioButton, RadioGroup, Card, Table, TableColumn, Select,
  Pagination, Breadcrumb, BreadcrumbItem, Col, Row, Cascader,
  Dialog, Message, Loading, MessageBox
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Header)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(MenuItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(Dialog)
Vue.use(Cascader)
Vue.use(Select)
Vue.use(Option)
// Vue.use(Message)
Vue.use(Loading)
// Vue.use(MessageBox)

Vue.prototype.$message = Message
Vue.prototype.$messageBox = MessageBox
